import type {
    DropdownData,
} from '../interfaces/input.interface';

export type DropdownSelection<T> = T | T[] | null;

type DropdownWithFlexibleSelection<T> = Omit<DropdownData<T>, 'selected'> & {
    selected: DropdownSelection<T>;
};

function asFlexibleDropdown<T>(
    dropdown: DropdownData<T>
): DropdownWithFlexibleSelection<T> {
    return dropdown as unknown as DropdownWithFlexibleSelection<T>;
}

export function getDropdownSelectedArray<T>(dropdown: DropdownData<T>): T[] {
    const selected = asFlexibleDropdown(dropdown).selected;

    if (selected === null) {
        return [];
    }

    return Array.isArray(selected) ? selected : [selected];
}

export function getDropdownSelectedSingle<T>(dropdown: DropdownData<T>): T | null {
    const selected = asFlexibleDropdown(dropdown).selected;

    if (selected === null || Array.isArray(selected)) {
        return null;
    }

    return selected;
}

export function setDropdownSelected<T>(
    dropdown: DropdownData<T>,
    selected: DropdownSelection<T>
): void {
    asFlexibleDropdown(dropdown).selected = selected;
}

export function setDropdownSelectedFromArray<T>(
    dropdown: DropdownData<T>,
    selected: T[],
    multiple: boolean
): void {
    setDropdownSelected(
        dropdown,
        multiple ? selected : selected[0] ?? null
    );
}